module.exports = __webpack_public_path__ + "static/media/vhcabs.07bc7102.png";